function CSRPolicy() {
    return (
        <main className="about" >
            {/* Own Story Section */}
            <section className="own_story">
                <div className="container">
                    <div className="own_story_data">
                        <div className="heading">
                            <h2>CSR Policy</h2>
                        </div>

                        <div className="content">
                            <p>This policy sets out the Company’s commitment & approach towards Corporate Social
                                Responsibility based on our philosophy of always acting in the interest of others be it our
                                clients, employees, vendors or the society that we operate in. The Company is committed to
                                the society for improving the quality of life of the communities we serve through the CSR
                                theme of ‘Building Sustainable Community’. The Company intends to be a significant
                                contributor to CSR initiatives in India by devising, implementing and contributing to
                                projects focused on education, enhancement of livelihood, equality, environmental
                                sustainability, and socio-cultural development in the areas where it operates.
                                Constitution of Corporate Social Responsibility Committee:</p>
                            <p>The Board of directors of the Company (“Board”) constituted a Corporate Social Responsibility
                                Committee (“CSR Committee”) in terms of Section 135 of the Companies Act, 2013 (“Act”).</p>

                            <h6 className="sub-heading">Focus Areas:</h6>


                            <p>In line with the requirements of the Act, the Company’s CSR programmes shall mainly focus on
                                the following areas:</p>

                            <p>promoting education, including special education and employment enhancing vocation skills
                                especially among children, women, elderly and the differently abled and livelihood
                                enhancement projects;</p>

                            <p>promoting gender equality, empowering women, setting up homes and hostels for women and
                                orphans, setting up old age homes, day care centers and such other facilities for senior
                                citizens and measures for reducing inequalities faced by socially and economically backward
                                groups;</p>

                            <p>ensuring environmental sustainability, ecological balance, protection of flora and fauna,
                                animal welfare, agroforestry, conservation of natural resources and maintaining quality of
                                soil, air and water;</p>

                            <p>measures for the benefit of armed forces veterans, war widows and their dependents;</p>

                            <p>initiating Green Drives focusing on cleaning and making India green by planting more trees or
                                harvesting rainwater, installing sewage treatment plant etc.</p>

                            <p>However, the Company may choose to undertake additional CSR Activities falling within the
                                purview of Schedule VII of the Act, as may be amended from time to time, based on the
                                recommendations of the CSR Committee and as may be approved by the Board.</p>

                            <h6 className="sub-heading"> Responsibility of the Board:</h6>


                            <p>The Board shall be responsible for –</p>

                            <p>Approving the CSR policy of the Company as may be recommended by the CSR Committee, subject
                                to such changes/modifications as the Board may deem fit.</p>

                            <p>Ensuring that in each financial year the Company spends such amounts for CSR activities as
                                may be stipulated in the Act and as may be amended from time to time.</p>

                            <p>Ensuring that the activities included in the CSR Policy are undertaken by the Company.</p>
                            <p>CSR Committee:</p>


                            <h6 className="sub-heading">The CSR Committee of the Company shall be responsible for:</h6>

                            <p>Formulating and recommending to the Board the CSR Policy which shall indicate activities to
                                be undertaken in terms of Section 135 read with Schedule VII of the Act and the Rules framed
                                thereunder with such amendments, modifications and/or alterations as may be made from time
                                to time. Any or all provisions of the CSR policy may be amended by the Board based on the
                                recommendations of the CSR Committee or sua sponte/suo motu either in accordance with any
                                statutory guidelines that may be issued from time to time or otherwise.</p>

                            <p>Recommending to the Board the CSR expenditure to be incurred.</p>

                            <p> Monitoring the implementation of the CSR Policy from time to time</p>


                            <h6 className="sub-heading">CSR Budget:</h6>


                            <p>The amounts to be spent by the Company shall be as stipulated under the Act with such
                                amendments, modifications and/or alterations as may be made from time to time and as
                                approved by the Board. Any surplus arising out of the CSR projects or programmes or
                                activities shall not form part of business profits of the Company.</p>

                            <h6 className="sub-heading">Target Communities & Project Locations:</h6>

                            <p>The Company’s target communities shall include children, marginalised youth and women,
                                differently abled, armed forces veterans, war widows and their dependents, socially and
                                economically backward groups and other such groups associated with our focus areas. Relevant
                                projects and locations pertaining to the outlined focus areas and target communities shall
                                be undertaken around the areas in which we operate as well as other identified locations
                                from time to time.</p>


                            <h6 className="sub-heading">Implementation, monitoring and review mechanism:</h6>


                            <p>The CSR activities will be driven by a Project Leader under the aegis of the CSR Committee
                                and the Board. The CSR Committee will play a significant role in assimilation of the CSR
                                policy across the Company at all levels and ensuring that the CSR initiatives are in line
                                with this policy;</p>

                            <p>The CSR Committee will be responsible for monitoring approved projects and fund disbursals
                                for such projects. The CSR Committee will put in place a transparent monitoring and
                                reporting mechanism for ensuring effective implementation of the projects, programmes and
                                activities proposed to be undertaken by the Company. Such monitoring mechanisms will include
                                onsite visits, meetings and progress/status reporting by the project team;</p>

                            <p>The CSR Committee shall periodically review the CSR project reports and the same shall be
                                presented to the Board at such intervals as the Board deems fit and atleast on an annual
                                basis.</p>


                            <h6 className="sub-heading"> Stakeholder Communication:</h6>


                            <p>The Company shall share updates regarding our key projects and its impact through our Annual
                                Report, or the Company’s web platforms and other relevant mechanisms from time to time</p>
                        </div>
                    </div>
                </div>
            </section>
            {/* End of Own Story Section */}
        </main>
    );
}

export default CSRPolicy;
